
const randomPassword = (length = 24, rules = (v) => []) => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%&*()-+{}[]<>Çç"|\\/.,'

  const generate = () => {
    let result = ''
    for (var i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * chars.length)
      result += chars.charAt(randomIndex)
    }
    return result
  }

  let result = generate()
  const validResult = () => !rules(result).some(v => typeof v === 'string')
  while (!validResult()) result = generate()
  return result
}

export default randomPassword
